module.exports = __webpack_public_path__ + "img/xl_sx.05e4b3bc.png";